import { playerAvatarParser } from '../commonInbounds/utils/playerAvatarInboundUtils';
import { booleanParser, numberParser, stringParser } from '../inboundParsers';
import { seatIndexParser } from './utils/pokerInboundUtils';
export const SIT_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'isSelfSitting', parser: booleanParser },
        { name: 'playerId', parser: numberParser },
        { name: 'seatIndex', parser: seatIndexParser },
        { name: 'numChips', parser: numberParser },
        { name: 'numChipsInBank', parser: numberParser },
        { name: 'score', parser: numberParser },
        { name: 'isSittingOut', parser: booleanParser },
        { name: 'avatar', parser: playerAvatarParser },
        { name: 'flagId', parser: numberParser },
        { name: 'flagUrl', parser: stringParser }
    ]
};
